import { gql } from '@apollo/client';
import { mutate } from '../../../../../../common/graphql';

const UPDATE_SUBMISSION_SUBMIT_FOR_APPROVAL = gql`
  mutation submissionSubmitForApproval($input: DeveloperSubmissionSubmitForApprovalInput!) {
    developerSubmissionSubmitForApproval(input: $input) {
      submission {
        id
      }
      isFirstSubmission
    }
  }
`;

export interface SubmissionSubmitForApprovalMutation {
  developerSubmissionSubmitForApproval: SubmissionSubmitForApprovalResult;
}

export interface SubmissionSubmitForApprovalResult {
  submission: { id: string };
  isFirstSubmission: boolean;
}

export interface DeveloperSubmissionSubmitForApprovalInput {
  id: string;
}

export function submissionSubmitForApproval(input: DeveloperSubmissionSubmitForApprovalInput) {
  return mutate<DeveloperSubmissionSubmitForApprovalInput, SubmissionSubmitForApprovalMutation>(
    UPDATE_SUBMISSION_SUBMIT_FOR_APPROVAL,
    input,
  );
}
